// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let defaultOptions = {
  width: 256,
  height: 256,
  margin: 2,
  color: {
    dark: "#212121",
    light: "#FFFFFF"
  },
  errorCorrectionLevel: "M"
};

function isQRCodeAvailable() {
  return Stdlib_Option.isSome(Primitive_option.fromNullable(window.QRCode));
}

function generateQRCode(text, options) {
  let opts = Stdlib_Option.getOr(options, defaultOptions);
  return new Promise((resolve, reject) => {
    window.QRCode.toDataURL(text, opts, (error, url) => {
      if (error == null) {
        return resolve(url);
      } else {
        return reject(error);
      }
    });
  });
}

export {
  defaultOptions,
  isQRCodeAvailable,
  generateQRCode,
}
/* No side effect */
